<template>
  <div class="flex flex-col gap-6 z-1000 w-full h-full">
    <loading-overlay v-if="loading" :value="loading" />
    <div v-else class="block-container">
      <BaseTabs :tabs="tabs" :active-tab="activeTab" @change:tab="changeTab">
        <template #action>
          <div
            v-if="$route.name !== 'organization_item_view'"
            class="flex items-center gap-2"
          >
            <el-tooltip
              v-if="!isCreate"
              :content="$t('Режим просмотра')"
              placement="top"
            >
              <Button variant="outline" size="icon" @click="goToView">
                <svg-icon name="huge-eye" class="w-4 h-4 text-foreground" />
              </Button>
            </el-tooltip>
            <Button variant="default" :disabled="loader" @click="submitForm">{{
              $t("Сохранить")
            }}</Button>
          </div>
          <div v-else class="flex items-center gap-3">
            <!-- TODO: нет backend API для печати и скачивания -->
            <!-- <Button variant="outline" size="icon">
              <svg-icon name="huge-print" class="w-4 h-4 text-foreground" />
            </Button>
            <Button variant="outline" size="icon">
              <svg-icon name="huge-download" class="w-4 h-4 text-foreground" />
            </Button> -->
            <Button variant="outline" size="icon" @click="goToEdit">
              <svg-icon name="huge-edit" class="w-4 h-4 text-foreground" />
            </Button>
          </div>
        </template>
      </BaseTabs>
    </div>

    <component
      :is="currentTabComponent"
      :form="form"
      ref="activeForm"
      class="flex-1 w-full h-full"
    />
  </div>
</template>

<script>
import LoadingOverlay from "@/shared/ui/custom/components/LoadingOverlay.vue";
import BaseTabs from "@/shared/ui/custom/tabs/BaseTabs.vue";
import Button from "@/shared/ui/button/Button.vue";
import DataOrganization from "./tabs/DataOrganization.vue";
import UserSettingRight from "./tabs/OrganizationSettingRight.vue";
import {
  getOrganizationItem,
  updateOrganization,
  createOrganization,
} from "@/entities/organization";

import OrganizationStructure from "./tabs/OrganizationStructure.vue";
import OrganizationAssignedRights from "./tabs/OrganizationAssignedRights.vue";
import OrganizationHistory from "./tabs/OrganizationHistory.vue";
export default {
  name: "OrganizationItem",
  components: {
    LoadingOverlay,
    BaseTabs,
    Button,
    DataOrganization,
    UserSettingRight,

    OrganizationStructure,
    OrganizationAssignedRights,
    OrganizationHistory,
  },
  data() {
    return {
      loading: false,
      loader: false,
      activeTab: "data",

      form: {
        name: "",
        name_kz: "",

        short_name_kz: "",
        short_name_ru: "",
        logo: null,

        created_at: null,
        code: null,
        head_full_name: null,
        head_position_kz: null,
        head_position_ru: null,
        legal_address_kz: null,
        legal_address_ru: null,

        email: null,
        phone: null,
        website: null,
        work_time_from: null,
        work_time_to: null,

        bank_name: null,
        iik: null,
        bik: null,
        kbe: null,
      },
    };
  },
  computed: {
    uuid() {
      return this.$route.params.id;
    },

    isCreate() {
      return this.$route.name === "organization_new";
    },

    tabs() {
      const tabs = {
        data: {
          label: this.$t("Данные организации"),
          icon: "huge-text-config",
        },
      };

      // if (this.$route.name === "organization_item_view") {
      //   tabs.organStructure = {
      //     label: this.$t("Структура организации"),
      //     icon: "huge-branch",
      //   };
      //   tabs.assignedRights = {
      //     label: this.$t("Назначенные права"),
      //     icon: "huge-key",
      //   };
      // }

      if (this.$route.name === "organization_item_view") {
        tabs.history = {
          label: this.$t("История"),
          icon: "huge-history",
        };
      }

      return tabs;
    },

    currentTabComponent() {
      const tabComponents = {
        data: DataOrganization,
        organStructure: OrganizationStructure,
        assignedRights: OrganizationAssignedRights,
        history: OrganizationHistory,
      };

      return tabComponents[this.activeTab] || null;
    },
  },
  watch: {
    "$route.name"() {
      if (this.uuid && this.uuid !== "new") {
        this.getOrganizationItem();
      }
    },
    "$route.query.tab": {
      immediate: true,
      handler(tab) {
        if (tab) {
          this.activeTab = tab;
        }
      },
    },
    tabs: {
      immediate: true,
      handler(tabs) {
        if (!tabs[this.activeTab]) {
          this.activeTab = Object.keys(tabs)[0];
        }
      },
    },
  },
  async created() {
    if (this.uuid && this.uuid !== "new") {
      await this.getOrganizationItem();
    }
  },

  methods: {
    async getOrganizationItem() {
      try {
        this.loading = true;
        let data = await getOrganizationItem(this.uuid);
        if (data.success && data.payload) {
          this.form = data.payload;
        }
      } finally {
        setTimeout(() => (this.loading = false), 500);
      }
    },
    changeTab(tab) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab,
        },
      });
    },
    goToView() {
      this.$router.push({
        name: "organization_item_view",
        params: { id: this.uuid },
        query: { tab: this.activeTab },
      });
    },
    goToEdit() {
      this.$router.push({
        name: "organization_item",
        params: { id: this.uuid },
        query: { tab: this.activeTab },
      });
    },
    async submitForm() {
      const form = this.$refs.activeForm;
      if (!form || !form.validate) return;
      const valid = await form.validate();
      if (!valid) return;
      if (this.uuid && this.uuid !== "new") {
        await this.updateOrganization();
      } else {
        await this.createOrganization();
      }
    },
    applyServerErrors(error) {
      const detail = error?.response?.data?.detail;
      const form = this.$refs.activeForm;
      if (form?.setServerErrors && Array.isArray(detail)) {
        form.setServerErrors(detail);
      }
    },
    buildPayload() {
      const { ...payload } = this.form;
      return payload;
    },
    async createOrganization() {
      this.loader = true;
      try {
        const data = await createOrganization(this.buildPayload());
        if (data?.success && data?.payload) {
          this.$router.push({
            name: "organization_item_view",
            params: { id: data.payload?.id },
          });
        }
      } catch (error) {
        this.applyServerErrors(error);
      } finally {
        this.loader = false;
      }
    },
    async updateOrganization() {
      this.loader = true;
      try {
        const data = await updateOrganization(this.uuid, this.buildPayload());
        if (data?.success) {
          this.$router.push({
            name: "organization_item_view",
            params: { id: this.uuid },
          });
        }
      } catch (error) {
        this.applyServerErrors(error);
      } finally {
        this.loader = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  @apply h-10 flex justify-center items-center p-4 bg-card border;
  @apply border-border rounded outline-none;
  &:active {
    transform: scale(0.98);
  }
}

.menu {
  @apply w-[282px] flex flex-col p-2 gap-2 bg-card rounded-xl outline outline-1 outline-offset-[-1px];
}

.item {
  @apply flex items-center px-3 py-2 gap-3 rounded-lg cursor-pointer transition-colors;
  svg {
    @apply text-foreground;
    &.danger {
      @apply text-red-400;
    }
  }

  span {
    @apply text-base font-medium leading-6 text-foreground;
    &.danger {
      @apply text-red-400;
    }
  }
}
</style>
